import { HLS_KR, HLS, SS, DASHWV } from '../../utils/playerConstants';

const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;
// DASHWV
multipleaudio.DASHWV = {};
multipleaudio.DASHWV.vod = true;
multipleaudio.DASHWV.live = true;
multipleaudio.DASHWV.timeshift = true;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [DASHWV, SS, HLS];
supported_stream_types.live = [DASHWV, HLS_KR, HLS];
supported_stream_types.timeshift = [DASHWV, HLS_KR, HLS];
let mac_address = navigator.avClient && navigator.avClient.id ? navigator.avClient.id : null;
mac_address = mac_address || 'ARRIS-VIP1113-_38:C9:86:1D:7C:D6';
export default {
  appKey: '2071c861f5e928655ff9ba70710309dc',
  appSubkey: 'generic',
  // Request params
  device_category: 'stb',
  /*device_id:"nousar",*/
  device_id: mac_address,
  device_manufacturer: 'activevideo',
  device_model: 'cloudtv',
  device_name: 'Chrome',
  device_so: 'Chrome',
  device_type: 'ott',
  stream_type: 'dashwv',
  //multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  //supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  akamai_id: 'SonySTV', // TO CHANGE
  useEpgPostals: false,
  serial_id: mac_address,
  firmwareversion: '003.000.006',
  appversion: '513',
  //akamai_mfwk: 'mfwkstbkaon-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwkstbkaon-api.clarovideo.net' : 'http://mfwkstbkaon-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/arris/config.js